import { useMemo } from 'react';

// One clock reading per DATA change, not per render (PG-55). A chart that
// takes `nowMs` recomputes its axis, decimation and annotation whenever that
// number moves, so `Date.now()` in the render body would redo them all every
// time. `dep` is the trigger, not an input: re-read the clock when the data
// reloads. eslint sees a dep the factory never reads and calls it unnecessary,
// but removing it would freeze the reading at first render forever.
export function useClockOn(dep: unknown): number {
  // eslint-disable-next-line react-hooks/exhaustive-deps
  return useMemo(() => Date.now(), [dep]);
}
